import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { environment } from 'src/environments/environment';

const BASEURL = environment.apiBase;

@Injectable({
  providedIn: 'root'
})
export class UserMeetBalanceService {
  private apiUrl = '/api/user_meet_balances'; // Ajusta este endpoint según tu API Rails

  constructor(private http: HttpClient) { }

  getUserBalances(): Observable<any[]> {
    return this.http.get(`${BASEURL}/v3/balances`, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    })
      .pipe(
        tap((response: any) => {
          //console.log(response);
        }),
        //catchError(this.handleError<any>('login', []))
      );
  }
}
